import i18nFactory from '@yandex-int/i18n';
import { get } from 'lodash';

import { ValidationResultItem } from '../../../typings/common';
import { createErrorsMapper } from '../../ErrorsMapper/ErrorsMapper';
import { formatNumber } from '../../FormatHelpers/FormatHelpers';

import * as keyset from './BannerPriceErrorMapper.i18n';

const i18n = i18nFactory(keyset);

export const BannerPriceErrorMapper = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: [idx, 'priceOld'],
            codes: [
                {
                    code: 'BannerDefectIds.Gen.BANNER_PRICE_GREATER_THAN_OLD',
                    message: (): string => i18n('priceOld-greater-then-price')
                }
            ]
        },
        {
            path: [idx, 'price'],
            codes: [
                {
                    code: 'DefectIds.INVALID_VALUE',
                    message: (): string => i18n('needs-price')
                }
            ]
        },
        {
            path: [idx, 'price'],
            codes: [
                {
                    code: 'NumberDefectIds.MUST_BE_LESS_THEN_OR_EQUAL_TO_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('price-greater-then-max-with-value', {
                            value: formatNumber(get(err, 'params.max', 0), 2)
                        });
                    }
                }
            ]
        },
        {
            path: [idx, 'price'],
            codes: [
                {
                    code: 'NumberDefectIds.MUST_BE_GREATER_THAN_MIN',
                    message: (err: ValidationResultItem): string => {
                        return i18n('price-greater-then-min', {
                            value: formatNumber(get(err, 'params.min', 0), 2)
                        });
                    }
                }
            ]
        },
        {
            path: [idx, 'priceOld'],
            codes: [
                {
                    code: 'NumberDefectIds.MUST_BE_LESS_THEN_OR_EQUAL_TO_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('priceOld-greater-then-max-with-value', {
                            value: formatNumber(get(err, 'params.max', 0), 2)
                        });
                    }
                }
            ]
        },
        {
            path: [idx, 'priceOld'],
            codes: [
                {
                    code: 'NumberDefectIds.MUST_BE_GREATER_THAN_MIN',
                    message: (err: ValidationResultItem): string => {
                        return i18n('priceOld-greater-then-min', {
                            value: formatNumber(get(err, 'params.min', 0), 2)
                        });
                    }
                }
            ]
        },
        {
            path: [idx, ''],
            codes: [
                {
                    code: 'VALIDATE_ERROR',
                    message: (): string => i18n('price-validate-error')
                }
            ]
        }
    ],
    error => i18n('price-error-text')
);
